<template>
  <div class="section-accounts">
    <h5 class="heading-h5">Voz</h5>
  </div>
</template>
